export const BROWSER = true;
export const DEV = false;
export const NODE = false;
